import React from "react";
import { Switch, Route } from "react-router-dom";
import {
  HomeApp,
  RoamingApp,
  LocalDataApp,
  PhoneApp,
  SmartPhoneApp,
  SimPlansApp,
  NotFoundApp,
  PlanApp,
} from "@pages";

export default function App() {
  return (
    <div>
      <Switch>
        <Route exact path="/" component={HomeApp} />
        <Route path="/:lang/home.html" component={HomeApp} />
        <Route path="/:lang/plans.html" component={PlanApp} />
        <Route path="/:lang/phones.html" component={PhoneApp} />
        <Route path="/:lang/roaming.html" component={RoamingApp} />
        <Route path="/:lang/smartphones.html" component={SmartPhoneApp} />
        <Route path="/:lang/topup-vas.html" component={LocalDataApp} />
        <Route path="/:lang/plan-prepaid.html" component={SimPlansApp} />
        <Route path="*" component={NotFoundApp} />
      </Switch>
    </div>
  );
}
